
















import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { Component, Vue } from "vue-property-decorator";
import { FeatureModule } from "@/store/modules/feature.store";

@Component
export default class TheThgList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  route(route: string) {
    this.$router.push({ name: route });
  }

  get items() {
    return [
      {
        icon: "mdi-home-outline",
        text: "Home",
        link: "/overview",
        isEnabled: true
      },
      {
        icon: "mdi-plus",
        text: this.$t("report.thgOverview.action"),
        link: "/thghome",
        isEnabled: true
      },
      {
        icon: "mdi-car-outline",
        text: this.$t("report.thgOverview.vehicle.title"),
        link: "/vehicle",
        isEnabled: true
      },
      {
        icon: "mdi-ev-station",
        text: this.$t("report.thgOverview.chargingStation.title"),
        link: "/charging-station",
        isEnabled: FeatureModule.isThgFeatureEnabled.isChargingStationEnabled
      },
      {
        icon: "mdi-file-document-outline",
        text: this.$t("report.thgBillingOverview.title"),
        link: "/billing",
        isEnabled: true
      },
      {
        icon: "mdi-account-multiple-plus-outline",
        text: this.$t("report.thgOverview.invite"),
        link: "/invite",
        isEnabled: FeatureModule.isInviteFriendsEnabled
      }
    ].filter(item => item.isEnabled); // FIXME: WTF why is this different to `ThePartnerList` implementation
  }
}
